import { useContext } from 'react';
import { EpicorCustomerContext } from '../providers/EpicorCustomerProvider';

const useEpicorCustomer = () => useContext(EpicorCustomerContext);
export default useEpicorCustomer;